(() => {
  function proxyURL(value, messages) {
    if (!value) throw new Error(messages.serviceNotConfigured);

    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin || !url.pathname.startsWith('/apps/')) {
      throw new Error(messages.serviceNotConfigured);
    }
    return url.href;
  }

  async function post(value, payload, messages) {
    // AbortController + setTimeout instead of AbortSignal.timeout() for Safari < 16 support.
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(proxyURL(value, messages), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
        signal: controller.signal,
      });
      if (!response.ok) throw new Error(messages.requestFailed);
      return await response.json();
    } finally {
      clearTimeout(timeoutId);
    }
  }

  class UbiqueSignIn extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const email = form.elements.email;
      const button = form.querySelector('button');
      const buttonLabel = button.querySelector('.btn__text');
      const errorMessage = form.querySelector('[role="alert"]');
      const result = form.querySelector('[data-result]');
      const messages = {
        accountFound: this.dataset.textAccountFound,
        accountNotFound: this.dataset.textAccountNotFound,
        checking: this.dataset.textChecking,
        continue: this.dataset.textContinue,
        requestAccount: this.dataset.textRequestAccount,
        requestFailed: this.dataset.textRequestFailed,
        serviceNotConfigured: this.dataset.textServiceNotConfigured,
        signIn: this.dataset.textSignIn,
        timeout: this.dataset.textTimeout,
        unexpectedResponse: this.dataset.textUnexpectedResponse,
      };

      button.disabled = false;
      email.addEventListener('input', () => {
        result.hidden = true;
        errorMessage.textContent = '';
      });
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (button.disabled) return;
        email.value = email.value.trim();
        if (!form.reportValidity()) return;
        const submittedEmail = email.value;
        button.disabled = true;
        buttonLabel.textContent = messages.checking;
        errorMessage.textContent = '';
        result.hidden = true;
        try {
          const data = await post(this.dataset.endpoint, { email: submittedEmail }, messages);
          if (typeof data.exists !== 'boolean') throw new Error(messages.unexpectedResponse);
          if (email.value.trim() !== submittedEmail) return;
          this.querySelector('[data-message]').textContent = data.exists
            ? messages.accountFound
            : messages.accountNotFound;
          const link = this.querySelector('[data-link]');
          link.href = data.exists ? this.dataset.loginUrl : this.dataset.registerUrl;
          link.querySelector('.btn__text').textContent = data.exists ? messages.signIn : messages.requestAccount;
          result.hidden = false;
        } catch (caughtError) {
          errorMessage.textContent =
            caughtError.name === 'AbortError' || caughtError.name === 'TimeoutError'
              ? messages.timeout
              : caughtError.message;
        } finally {
          button.disabled = false;
          buttonLabel.textContent = messages.continue;
        }
      });
    }
  }

  if (!customElements.get('ubique-sign-in')) customElements.define('ubique-sign-in', UbiqueSignIn);
})();
